import Axios from 'axios';
import {retrieveCollegiaAccessToken} from "./Helpers";

/**
 * Request options.
 *
 * @type {{baseURL: *, withCredentials: boolean, timeout: number}}
 */
const options = {
    baseURL: process.env.REACT_APP_API,
    withCredentials: false,
    timeout: 960000,
    headers: {
        Authorization: `Bearer ${retrieveCollegiaAccessToken()}`,
    },
};

// creating the axios instance.
const Request = Axios.create(options);

/**
 * Creating custom function to parse the params.
 *
 *
 * @example: Create like url?parameter=value&parameter2=valor&parameterArray=[...values]
 * @param params
 * @return {string}
 */
Request.parseParams = (params) => {
    return Object.keys(params).map(function(key) {
        return [key, params[key]].map(encodeURIComponent).join("=");
    }).join("&");
};

export default Request;